import { render, staticRenderFns } from "./OrganisationCreation.vue?vue&type=template&id=f97b60dc&scoped=true"
import script from "./OrganisationCreation.vue?vue&type=script&lang=js"
export * from "./OrganisationCreation.vue?vue&type=script&lang=js"
import style0 from "./OrganisationCreation.vue?vue&type=style&index=0&id=f97b60dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b60dc",
  null
  
)

export default component.exports